import clsx from 'clsx';

interface FieldsetProps {
  legend: string;
  children: React.ReactNode;
  className?: string;
}

export const Fieldset = ({ legend, children, className }: FieldsetProps) => {
  return (
    <fieldset className={clsx('space-y-4', className)}>
      <legend className="text-xl font-semibold text-gray-900">{legend}</legend>
      {children}
    </fieldset>
  );
};
